const translations = {
  en: {
    translation: {
      "10001": "Log In",
      "10002": "Forgot Password",
      "10003": "Remember me",
      "10004": "Create a new account",
      "10005": "Activate Account",
      "10006": "By logging in, you accept our use of essential cookies as described in our Privacy Policy",
      //regsiter
      "10007": "Full Name",
      "10008": "First name",
      "10009": "Last name",
      "10010": "Username",
      "10011": "Email ",
      "10012": "Password",
      "10013": "Confirm password ",
      "10014": "I have read and agree to the",
      "100114": "Terms and Conditions and privacy policy",
      "100115": "and",
      "100116": "Privacy Policy",


      "10015": "Register",
      "10016": "Already have an account? Login here",
      //forgot password page
      "10017": "Forgot your password",
      "10018": "Please enter your registered email address for receiving the verification code",
      "10019": "Enter your email address",
      "10020": "Send code",
      "10021": "Cancel",
      "10022": "VERIFY YOUR EMAIL ADDRESS",
      "10023": "A verification code has been sent to",
      "10024": "Please check your inbox and enter the verification code below to verify your email address.Note: If you don’t see the email right away, please check your spam or junk folder. Sometimes email delivery may be delayed by a few minutes. If you still haven’t received the code after a short wait, you can request a new one.",
      "10025": "Resend",
      "10026": "Reset",
      //actiavte account page
      "10027": "Activate your account",
      "10028": "Check your email for the confirmation code and enter it here",
      "10029": "Account already activated? Login here!",
      //home page
      "10030": "Home",
      "10031": "Account",
      "10032": "Saved Lasers",
      "10033": "Buy Calculations",
      "10034": "Report a Bug",
      "10035": "Logout",
      "10036": "Your Safety Starts here. Pick a calculator and start calculating",
      "10037": "Innovative Laser Calculations from the experts in laser safety",
      "10038": "Point & Extended",
      "10039": "Fiber Optic",
      "10040": "Diffuse Reflection",
      "10041": "Lookup table",
      "10042": "The point source has a laser emission from a single point and has a miniscule diameter compared with the viewing distance while an extended source is the opposite with laser emitted from various points and a relatively large diameter.",
      "10043": "Utilises flexible quartz or glass fibres that use total internal reflection to pass light through thousands of glancing reflections. Optical sources typically used are laser diodes, LEDs and VCSEL (Vertical Cavity Surface Emitting Laser).",
      "10044": "This happens when different parts of a beam strike a surface and reflect over a wide range of angles.The reflection typically strikes a rough or irregular surface.",
      "10045": "Find out the accessible emission limit for all laser class in relation to the laser wavelength you want to calculate.Evaluate the laser properties to determine safety values for eye and skin.",
      //security page
      "10046": "Current Password",
      "10047": "New Password",
      "10048": "Submit ",
      "10049": "Security",
      "10050": "Change Password",

      "10051": "Click the expand icon to expand and view the selected saved laser",
      "10052": "My saved Lasers",
      "10053": "Laser saved",
      "10054": "Saved Lasers",

      "10055": "One off",
      "100155": "Calculation",
      "10056": "Bronze",
      "10057": "Silver",
      "10058": "Gold",
      "10059": "Your Available Calculations",
      "10060": "Calculations",
      "10061": "Billed Annually",
      "10062": "Unlimited Calculations",
      "10063": "Buy Now",
      "10064": "Edit Profile",
      "10065": "Save Changes",

      "10066": "Looking to change your email or password?",
      "100166": "Click here",

      "10067": "Title",
      "10068": "Select Title",
      "10069": "Description",
      "10070": "Enter description",
      "10071": "Describe the problem you have encountered. Please be as specific as possible",
      "10072": "Submit report",
      "10073": "Laser Operation",
      "10074": "Source Type",
      "10075": "Settings",
      "10076": "Wavelength",
      "10077": "Exposure Duration",
      "10078": "Laser Power",
      "10079": "Energy",
      "10080": "Beam Diameter ",
      "10081": "Beam Divergence",
      "10082": "Distance to target",
      "100182": "Distance",

      "10083": "Fiber Core Diameter",
      "10084": "Single mode",
      "10085": "Multimode-Step Index",
      "10086": "Multimode-Graded Index",
      "10087": "Numerical Aperture",
      "10088": "Peak Power",
      "10089": "Pulse Frequency",
      "10090": "Average Power",
      "10091": "Albedo",
      "10092": "Surface to Eye Distance",
      "10093": "Laser to Surface Distance",
      "10094": "Laser Output Power",
      "10095": "Calculate",
      "10096": "Continuous Wave",
      "10097": "Single Pulse",
      "10098": "Repetitively Pulsed",
      "10099": "Point source",
      "10100": "Extended source",
      "10101": "Maximum Permissible Emission",
      "10102": "Accessible Emission",
      "10103": "Eye Safety Ratio",
      "10104": "EYE",
      "10105": "Actual AE",
      "10106": "SKIN",
      "10107": "Skin Safety Ratio",
      "10108": "The configuration that has been entered is Dangerous for the Eye",
      "10109": "The configuration that has been entered is Safe for the Eye",
      "10110": "The configuration that has been entered is Marginally Safe for the Eye",

      "101108": "The configuration that has been entered is Dangerous for the Skin",
      "101109": "The configuration that has been entered is Safe for the Skin",
      "101110": "The configuration that has been entered is Marginally Safe for the Skin",
      "10111": "Beam Properties",
      "10112": "Spot Size",
      "10113": "Limit Aperture",
      "10114": "Applicable Beam Area",
      "10115": "Spectrum",
      "10116": "Nominal ocular hazard distance",
      "10117": "Extended Nominal ocular hazard distance",
      "10118": "MPE details",
      "10119": "More Information",
      "10120": "Angular parameters",
      "10121": "Number of pulses",
      "10122": "Pulse train duration",
      "10123": "Laser Protective Eyewear",
      "10124": "Correction Factors & Timebases",
      "101124": "Correction Factor",
      "101125": "Timebases",


      "10125": "When checked, this setting will hide the disclaimer window that appears when you try to submit the calculation.",
      "10126": "Apply Settings",
      "10127": "Hide Disclaimer",
      "10128": "Don't show again",
      "10129": "Remaining Calculations",
      "10130": "Accessible Emission Limits",
      "10131": "Overall",
      "10132": "Class",
      "10133": "Laser Class",
      "10134": "Condition",
      "10135": "This product is classified as a class 4 laser",
      "10136": "Buy Laser Classification Labels Here!",
      "10137": "Do you want your product to be accredited?",
      "10138": "Visit our accredited testing center",
      "10139": "More info",
      "10140": "for",
      "10141": "Emission Hazard Value",
      "10142": "Pass/Fail",
      "10143": "Pulse duration ",
      "10144": "Timebase ",
      "10145": "Value ",
      "10146": "Measurement aperture diameters and measurement distances",
      "10147": "Aperture Stop",
      "10148": "Aperture Distance",
      "10149": "Angular Subtense",
      "10150": "Optical Density",
      "10151": "Results ",
      "10152": "RB Number",
      "10153": "LB Number for Glass",
      "10154": "LB Number for Plastic",
      "10155": "Nominal OD",
      "10156": "Nominal Optical Density is calculated at the logarithm of the quotient of the accessible emission and maximum permissible exposure",
      "10157": "The formula is used to ensure laser safety by determining the required attenuation of laser exposure.",
      "10158": "Where ",
      "10159": "Solution ",
      "10160": "Note: The higher the OD, the greater the attenuation required to protect from hazardous laser exposure",
      "10161": "Stay protected. Buy your Laser Protective Eyewear here! ",
      "10162": "The EN 208 standard only applies to lasers that emit wavelengths in the visible section of the wavelength",
      "10163": "If the beam diameter is larger than the limit aperture of 7mm, then the selection can be based on the fraction of the power that would pass through a 7mm aperture.",
      "10164": "If the beam diameter is larger that the 7mm limit aperture",
      "10165": "Adjusted power/energy",
      "10166": "Use the adjusted power/energy to determine the appropriate RB number from BS EN 208",
      "10167": "To calculate the adjusted power/ energy density",
      "10168": "If the beam diameter is larger than 15mm, the function values for d = 15mm shall be used",
      "10169": "Multiply the actual power/energy density by the correction factor",
      "10170": "Formula ",
      "10171": "Use the corrected value to determine the appropriate eyewear rating from table B1 of BS EN 207:2017",
      "10172": "Note: This adjustment ensures that the calculated values align with the standard guidelines for glass eyewear safety",
      "101172": "Note: This adjustment ensures that the calculated values align with the standard guidelines for plastic eyewear safety",

      "10173": "Is there something wrong with the results? CLick here to report a bug.",

      "50001": "Online Laser Safety Safety Calculation Software to IEC 60825-1",
      "50002": "Realtime LSS is the easy-to-use online laser safety calculator, fully compliant with international standard IEC 60825-1: Safety of Laser Products - Part 1.",
      "50003": "Try it Now",
      "50004": "View Pricing",
      "50005": "RealTime LSS provides on-the-go access, making it ideal for quick assessments whether in the lab or in the field.",
      "50006": "Calculate important laser safety parameters, including:",
      "50007": "Maximum Permissible Exposure (MPE) calculation",
      "50008": "Accessible Emission Limits (AEL) calculation",
      "50009": "Laser Classification",
      "50010": "Diffuse Reflection calculations",
      "50011": "Fiber Optic Assessments",
      "50012": "RealTime LSS is developed by Lasermet, a globally recognized authority in laser safety. With decades of experience in laser safety standards, consultancy, and technology. Lasermet provides trusted solutions for ensuring compliance with IEC-60825-1 and other international regulations.",
      "50013": "Visit Lasermet",
      "50014": "Pricing Page",
      "50015": "Cut Through the Guesswork—Buy Credits That Matter.",
      "50016": "Choose a flexible plan and start running precise laser safety calculations instantly.",
      "50017": "Calculations",
      "50018": "per calculation",
      "50019": "Buy for myself",
      "50020": "Buy for someone else",
      "50021": "To buy for someone else, complete the payment first. A license key will be emailed to you—share this key with the recipient so they can activate it using their own account to receive their calculations.",
      "50022": "Purchase Form",
      "50023": "Retype Email",
      "50024": "Company",
      "50025": "Company Address",
      "50026": "Continue to checkout",
      "50027": "You're almost there!",
      "500127": " Log in",
      "500128": "Register",
      "500129": "to complete your personal purchase.",
      "500130": "or",

      "50028": "Not Ready to Buy? Test Our Free Calculator!",
      "50029": "Start Free Calculation",
      "50030": "Free Calculation",
      "50031": "Manage Subscription",
      "50032": "Subscribe Now",
      "50033": "Activate License",
      "50034": "Activate Purchased License here",
      "50035": "If your company has already purchased a license, enter the license key below to transfer the corresponding credits to your account.",
      "50036": "How it works",
      "50037": "This feature is for license keys purchased through a company's procurement or purchasing department.",
      "50038": "After purchase, the license key is sent to your designated contact (e.g., purchaser or admin).",
      "50039": "Request the license key internally and enter it here.",
      "50053": "Success!",
      "50054": "Your password has been successfully changed.",
      "50055": "Free",
      "50056": "Try out our pre-set IEC 60825 Laser Safety Calculator before buying!",
      "50057": "You are currently using the Free Version of the calculator. This version uses pre-set values that cannot be modified. To unlock full customization and for a more detailed result, please upgrade to the",
      "50058": "Premium Version.",
      "50060": "Please check your inbox or spam folder for the confirmation code and enter it below.",
      "50061": "Confirm Your Account!",
      "50062": "License Key",
      "50063": "Activate",
      "50064": "The associated credits will be added to your account immediately upon activation.",

      //Disclaimer
      "60001": "Disclaimer",
      "60002": "The laser safety parameter calculation tool provided on this website is designed to assist users in calculating laser safety parameters based on the IEC 60825-1 standard. While we strive to ensure the accuracy and reliability of the calculations, the tool is provided 'as is' without any guarantees or warranties of any kind, either express or implied.",
      "60003": "Accuracy and Limitations:",
      "60004": "Accuracy:",
      "60005": "The tool is designed to provide accurate calculations in the vast majority of scenarios, with an expected accuracy rate significantly higher than 99%. However, due to the complexity and the high number of possible scenarios, it is not feasible to verify the accuracy of every single calculation. Users should be aware that there may be instances where the tool provides incorrect results.",
      "60006": "No Professional Advice:",
      "60007": "The calculations and information provided by this tool are for informational purposes only and do not constitute professional advice. Users should not rely solely on the tool for making safety decisions and should consult with a qualified professional for specific advice tailored to their situation.",
      "60008": "Limitation of Liability:",
      "60009": "In no event shall Lasermet, its affiliates, or its licensors be liable for any direct, indirect, incidental, special, or consequential damages arising out of or in connection with the use of the tool, including but not limited to, any errors or omissions in the calculations, even if advised of the possibility of such damages.",
      "60010": "User Responsibility:",
      "60011": "Users are responsible for verifying the results obtained from the tool and for ensuring that they comply with all applicable safety standards and regulations. Lasermet does not assume any responsibility for the accuracy or completeness of the calculations or for any actions taken based on the results provided by the tool.",
      "60012": "By using this tool, you acknowledge and agree to the terms of this disclaimer and accept full responsibility for any risks associated with its use.",

      //Privacy Policy
      "60013": "Privacy Policy",
      "60014": "Lasermet Ltd. operates the RealTime LSS calculator and takes your privacy seriously. This Privacy Policy explains what personal information we collect, how we use it, how we protect it, and your rights regarding that information.",
      "60015": "Information We Collect",
      "60016": "We collect the following personal data to provide and improve our services:",
      "60017": "Name: Used to personalize your experience and account.",
      "60018": "Email: For account registration and secure access.",
      "60019": "Password: Stored in encrypted form for account security.",
      "60020": "Geolocation Data: We use IPinfo.io to collect general location information, including your IP address, for the sole purpose of determining your currency. This geolocation information is stored in a cookie.",
      "60021": "We do not collect any other personal data, and we do not send marketing emails or newsletters.",
      "60022": "Use of Cookies and JWT Web Tokens",
      "60023": "Cookies are small text files placed on your device to store certain information about your interactions with the App. We use cookies solely for the following purposes:",
      "60024": "Authentication: We store JWT web tokens in cookies for secure login sessions. This ensures that users remain logged in securely while using the platform.",
      "60025": "Session Management: Cookies help store user preferences and settings to enhance your experience.",
      "60026": "Currency Determination: Geolocation data is used to determine the appropriate currency for transactions. If geolocation services are disabled or unavailable, a default currency (British Pounds) will be used. Users may not be able to manually select a different currency. We do not store or use this data for any other purposes.",
      "60027": "We do not use cookies for advertising or tracking purposes. No third-party tracking tools, such as Google Analytics or Facebook Pixel, are implemented on our platform.",
      "60028": "You can manage or disable cookies by adjusting your browser settings. However, please note that disabling cookies may affect your ability to use certain features of the App, particularly those related to session authentication.",
      "60029": "How We Use Your Information",
      "60030": "The personal information we collect is used for:",
      "60031": "Creating and maintaining your user account.",
      "60032": "Authenticating user sessions securely.",
      "60033": "Enabling geolocation features for currency determination.",
      "60034": "Processing payments securely through Stripe.",
      "60035": "We do not sell, rent, or share your personal information with third parties for marketing purposes.",
      "60036": "Payments",
      "60037": "We process payments via Stripe, a secure third-party payment gateway. Your payment details are handled directly by Stripe, and we do not store any payment information on our servers. Please review Stripe’s privacy policy for more details on their practices.",
      "60038": "Data Protection and Security",
      "60039": "We are committed to ensuring that your information is secure. We have implemented appropriate technical and organizational measures to protect your personal information from unauthorized access, loss, or misuse. Passwords are stored in encrypted form, and JWT tokens are securely managed.",
      "60040": "Legal Compliance",
      "60041": "California Online Privacy Protection Act (CalOPPA): We allow users to visit our site anonymously and update our privacy policy whenever necessary. General Data Protection Regulation (GDPR): Users in the EU have the right to access, modify, or delete their personal information. You can contact us at office@lasermet.com to exercise these rights. California Consumer Privacy Act (CCPA): California residents have the right to request information on the personal data we collect and request its deletion. We do not sell personal data.",
      "60042": "Your Rights and Choices",
      "60043": "You have the following rights regarding your personal information:",
      "60044": "Access: You can request a copy of the personal data we hold about you.",
      "60045": "Correction: You can ask us to correct inaccurate information",
      "60046": "Deletion:",
      "60047": "You can request the deletion of your personal data, subject to legal requirements.",
      "60048": "Opt-Out:",
      "60049": "You may choose to opt-out of certain data collection practices by disabling cookies in your browser settings.",
      "60050": "Changes to This Privacy Policy",
      "60051": "We may update this Privacy Policy from time to time. Any changes will be posted on our website with a revised 'Effective Date.' We encourage you to review this policy periodically.",
      "60052": "Links to Other Sites",
      "60053": "Links to other sites in this web application direct you to our official Lasermet website. However, our social media links lead to our profiles on those respective platforms.This Privacy Policy does not apply to those third-party services, and we are not responsible for their privacy practices. We recommend reviewing their privacy policies before providing any personal information. ",
      "60054": "Contact Us",
      "60055": "If you have any questions or concerns about this Privacy Policy, or if you wish to exercise your rights regarding your personal data,",
      "60056": "please contact us at:",

      //Terms and Conditions
      "60057": "Terms and Conditions",
      "60058": "Welcome to the Laser Safety Parameter Calculation Tool known as RealTime LSS (“the Tool” or “Tool”) provided by Lasermet (“Company,” “we,” or “us”). These Terms of Use (“Terms”) govern your access to and use of the Tool. By accessing or using the Tool, you (“user” or “you”) acknowledge and agree to comply with these Terms. If you do not agree with any part of these Terms, you must refrain from accessing or using the Tool.",
      "60059": "We strongly encourage users to review these Terms in detail. For your convenience, we have included section headings for easy navigation.",
      "60060": "General Information",
      "60061": "Purpose:",
      "60062": "The Tool is designed to assist users in calculating laser safety parameters in compliance with the IEC 60825-1 standard. It is intended to provide general guidance on laser safety measures by generating calculations based on the data input by users. The Tool is not a substitute for expert advice or professional judgment.",
      "60063": "Informational Use Only:",
      "60064": "The Tool is provided solely for informational and educational purposes. It does not replace the need for professional consultation or adherence to formal laser safety regulations. Users must independently verify the accuracy and applicability of the calculations generated by the Tool to their specific circumstances.",
      "60065": "Governing Body Specific Compliance:",
      "60066": "The Tool is not tailored to meet the specific laser safety requirements of individual states or countries. Users are responsible for ensuring compliance with their specific laws.",
      "60067": "Acceptance of Terms:",
      "60068": " By accessing or using the Tool, you confirm that you have read, understood, and accepted these Terms of Use in their entirety. If you do not agree with these Terms, you must refrain from using the Tool.",
      "60069": "User Responsibilities",
      "60070": "Accuracy of Inputs:",
      "60071": "The accuracy and relevance of the Tool’s outputs depend entirely on the data inputs provided by users. It is your responsibility to input accurate, complete, and relevant data to achieve meaningful results.",
      "60072": "Verification of Results:",
      "60073": "You acknowledge and agree that the results provided by the Tool are estimates based on the IEC 60825-1 standard and may not account for state-specific requirements, including those in Illinois. It is your responsibility to verify the accuracy of these results before applying them in a real-world context.",
      "60074": "Prohibited Activities:",
      "60075": "You agree not to:",
      "60076": "Use the Tool for any unlawful, deceptive, or fraudulent purpose.",
      "60077": "Access the Tool through unauthorized means, including automated methods such as bots or scripts.",
      "60078": "Attempt to reverse-engineer, modify, copy, or create derivative works based on the Tool or its underlying algorithms.",
      "60079": "Distribute or share the outputs of the Tool in a manner that misrepresents its purpose.",
      "60080": "Share access with a user who is not an acting agent of said user.",
      "60081": "Compliance with Illinois and Federal Laws:",
      "60082": "Users operating in their specific state or county must ensure compliance with all applicable laws, including those governing laser safety, workplace safety, and radiation control. Users are encouraged to consult qualified professionals familiar with state specific safety regulations.",
      "60083": "Disclaimer of Warranties",
      "60084": "\"As Is\" and \"As Available\" Basis:",
      "60085": "The Tool is provided “as is” and “as available” without warranties of any kind, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, non-infringement, or error-free operation.",
      "60086": "No Guarantees:",
      "60087": "Lasermet does not guarantee the reliability, completeness, or accuracy of the Tool’s outputs. Users rely on the Tool at their own risk.",
      "60088": "No Professional Advice:",
      "60089": "The Tool does not constitute legal, technical, or professional advice. For decisions involving safety compliance, users should consult a certified laser safety officer or other qualified professionals.",
      "60090": "Limitation of Liability",
      "60091": "Limitation to the Extent Permitted by Law:",
      "60092": "To the fullest extent permitted under state and federal law, Lasermet and its affiliates, officers, employees, and agents are not liable for any direct, indirect, incidental, consequential, punitive, or special damages arising from your use of the Tool. This limitation includes, but is not limited to:",
      "60093": "Personal injury or property damage.",
      "60094": "Loss of profits, data, or business opportunities.",
      "60095": "Any reliance placed on the Tool’s outputs.",
      "60096": "Assumption of Risk:",
      "60097": "By using the Tool, you acknowledge and accept the inherent risks associated with reliance on automated calculations. You agree that Lasermet is not responsible for any adverse outcomes resulting from such reliance.",
      "60098": "Indemnification:",
      "60099": "You agree to indemnify, defend, and hold harmless Lasermet, its affiliates, officers, employees, and agents from any claims, liabilities, damages, or expenses arising from your use of the Tool or violation of these Terms.",
      "60100": "Intellectual Property",
      "60101": "Ownership:",
      "60102": "All rights, title, and interest in and to the Tool, including its content, design, algorithms, and functionality, remain the exclusive property of Lasermet. These rights are protected under U.S. and international copyright, trademark, and intellectual property laws.",
      "60103": "License:",
      "60104": "Lasermet grants you a non-exclusive, limited, revocable license to access and use the Tool for its intended purpose. This license does not transfer ownership rights to you.",
      "60105": "Restrictions:",
      "60106": "You may not:",
      "60107": "Reproduce, modify, or distribute the Tool without prior written consent from Lasermet.",
      "60108": "Remove, alter, or obscure any proprietary notices on the Tool.",
      "60109": "Privacy",
      "60110": "Data Collection:",
      "60111": "The Tool may collect anonymized data to improve its functionality and performance.",
      "60112": "Governing Law and Dispute Resolution",
      "60113": "Governing Law:",
      "60114": "These Terms shall be governed by and construed in accordance with the laws of the State of Illinois, excluding its conflict of laws principles.",
      "60115": "Jurisdiction and Venue:",
      "60116": "Any legal disputes arising from these Terms shall be subject to the exclusive jurisdiction of the state and federal courts located in Cook County, Illinois.",
      "60117": "Arbitration Clause:",
      "60118": "Disputes that cannot be resolved amicably shall be submitted to binding arbitration administered by an Illinois-based arbitration institution, such as the American Arbitration Association (AAA).",
      "60119": "Arbitration shall take place in Cook County, Illinois, and be conducted under AAA rules.",
      "60120": "The arbitrator’s decision shall be final and binding on both parties.",
      "60121": "Modifications to the Terms",
      "60122": "Right to Modify:",
      "60123": "Lasermet reserves the right to update or modify these Terms at any time without prior notice.",
      "60124": "Notification:",
      "60125": "Changes will take effect upon posting updated Terms on our website. Continued use of the Tool constitutes acceptance of the updated Terms.",
      "60126": "Termination",
      "60127": "Right to Terminate:",
      "60128": "Lasermet may terminate or suspend your access to the Tool at its sole discretion, with or without cause or notice.",
      "60129": "Effect of Termination:",
      "60130": "Upon termination, all rights granted under these Terms shall immediately cease.",
      "60131": "Acceptance of Terms",
      "60132": "By clicking “I Agree” or using the Tool, you confirm that you have read, understood, and agreed to these Terms of Use in their entirety."
    }
  },
  de: {
    translation: {
      "10001": "Anmeldung",
      "10002": "Passwort vergessen",
      "10003": "Benutzer merken",
      "10004": "Neues Konto erstellen",
      "10005": "Konto aktivieren",
      "10006": "Wenn Sie sich anmelden, akzeptieren Sie die Verwendung von Cookies, wie in unserer Datenschutzrichtlinie beschrieben.",
      "10007": "Vollständiger Name",
      "10008": "Vorname",
      "10009": "Nachname",
      "10010": "Benutzername",
      "10011": "E-Mail",
      "10012": "Passwort",
      "10013": "Passwort bestätigen",
      "10014": "Ich habe die Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung gelesen und stimme ihnen zu.",
      "100114": "Ich habe die Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung gelesen und stimme ihnen zu.",
      "100115": "Ich habe die Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung gelesen und stimme ihnen zu.",
      "100116": "Ich habe die Allgemeinen Geschäftsbedingungen und die Datenschutzerklärung gelesen und stimme ihnen zu.",


      "10015": "Registrieren",
      "10016": "Konto bereits vorhanden? Hier anmelden",
      "10017": "Passwort vergessen",
      "10018": "Bitte geben Sie Ihre registrierte E-Mail-Adresse ein, um den Verifizierungscode zu erhalten",
      "10019": "Geben Sie Ihre E-Mail Adresse ein",
      "10020": "Code senden",
      "10021": "Abbrechen",
      "10022": "VERIFIZIEREN SIE IHRE E-MAIL ADRESSE",
      "10023": "Ein Verifizierungscode wurde gesendet an",
      "10024": "Bitte überprüfen Sie Ihren Posteingang und geben Sie den unten stehenden Verifizierungscode ein, um Ihre E-Mail-Adresse zu bestätigen. Hinweis: Wenn Sie die E-Mail nicht sofort sehen, überprüfen Sie bitte Ihren Spam- oder Junk-Ordner. Manchmal kann sich die Zustellung der E-Mail um ein paar Minuten verzögern. Wenn Sie den Code nach einer kurzen Wartezeit immer noch nicht erhalten haben, können Sie einen neuen Code anfordern.",
      "10025": "Erneut senden",
      "10026": "Zurücksetzen",
      "10027": "Aktivieren Sie Ihr Konto",
      "10028": "Prüfen Sie Ihre E-Mail auf den Bestätigungscode und geben Sie ihn hier ein",
      "10029": "Konto bereits aktiviert? Hier anmelden!",
      "10030": "Startseite",
      "10031": "Konto",
      "10032": "Abgespeicherte Laser",
      "10033": "Berechnungen kaufen",
      "10034": "Einen Fehler melden",
      "10035": "Abmelden",
      "10036": "Ihre Sicherheit beginnt hier. Wählen Sie einen Kalkulator und beginnen Sie die Berechnung",
      "10037": "Innovative Laserberechnungen von den Experten für Lasersicherheit",
      "10038": "Punkt- & ausgedehnte Quelle",
      "10039": "Faseroptik",
      "10040": "Diffuse Reflektion",
      "10041": "Nachschlagetabelle",
      "10042": "Bei der Punktquelle erfolgt die Laser-Emission von einem einzigen Punkt aus und der Durchmesser ist vernachlässigbar im Vergleich zum Beobachtungsabstand, während eine ausgedehnte Quelle das Gegenteil darstellt. Dort wird die Strahlung aus einer Fläche emittiert, die einen relativ großen Durchmesser hat.",
      "10043": "Verwendet biegsame Quarz- oder Glasfasern, die mit Hilfe der Totalreflexion das Licht durch Tausende von Reflexionen leiten. Als optische Quellen werden in der Regel Laserdioden, LEDs und VCSEL (Vertical Cavity Surface Emitting Laser) verwendet.",
      "10044": "Diese tritt auf, wenn der Strahl auf eine raue oder unregelmäßige Oberfläche trifft und das Licht in viele verschiedene Richtungen gestreut wird.",
      "10045": "Ermitteln Sie die Grenzwerte der zugänglichen Strahlung für alle Laserklassen in Bezug auf die zu berechnende Laserwellenlänge und bewerten Sie die Lasereigenschaften, um die Sicherheitswerte für Augen und Haut zu bestimmen.",
      "10046": "Aktuelles Passwort",
      "10047": "Neues Passwort",
      "10048": "Eingabe ",
      "10049": "Sicherheit",
      "10050": "Passwort ändern",
      "10051": "Klicken Sie auf das „Erweitern“ Symbol, um die ausgewählten abgespeicherten Laser zu erweitern und anzuzeigen",
      "10052": "Meine abgespeicherten Laser",
      "10053": "Laser abgespeichert",
      "10054": "Abgespeicherte Laser",
      "10055": "Einmalige",
      "100155": "Berechnung",
      "10056": "Bronze",
      "10057": "Silber",
      "10058": "Gold",
      "10059": "Ihre verfügbaren Berechnungen",
      "10060": "Berechnungen",
      "10061": "Jährliche Abrechnung",
      "10062": "Unbegrenzte Anzahl an Berechnungen",
      "10063": "Jetzt kaufen",
      "10064": "Profil bearbeiten",
      "10065": "Änderungen Speichern",
      "10066": "Möchten Sie Ihre E-Mail oder Ihr Passwort ändern?",
      "100166": "Klicken Sie hier",
      "10067": "Überschrift",
      "10068": "Überschrift wählen",
      "10069": "Beschreibung",
      "10070": "Beschreibung eingeben",
      "10071": "Beschreiben Sie das Problem, auf das Sie gestoßen sind. Bitte seien Sie so spezifisch wie möglich",
      "10072": "Bericht abschicken",
      "10073": "Laserbetrieb",
      "10074": "Art der Quelle",
      "10075": "Eínstellungen",
      "10076": "Wellenlänge",
      "10077": "Bestrahlungsdauer",
      "10078": "Laserleistung",
      "10079": "Energie",
      "10080": "Strahldurchmesser ",
      "10081": "Strahldivergenz",
      "10082": "Abstand zum Ziel",
      "100182": "Abstand",
      "10083": "Durchmesser des Faserkerns",
      "10084": "Einzelmode",
      "10085": "Multimoden-Stufenindex",
      "10086": "Multimoden-Gradientenindex",
      "10087": "Numerische Apertur",
      "10088": "Spitzenleistung",
      "10089": "Pulsfrequenz",
      "10090": "Mittlere Leistung",
      "10091": "Albedo",
      "10092": "Abstand zwischen Oberfläche und Auge",
      "10093": "Abstand zwischen Laser und Oberfläche",
      "10094": "Laser-Ausgangsleistung",
      "10095": "Berechnen",
      "10096": "Dauerstrich",
      "10097": "Einzelpuls",
      "10098": "Wiederholt gepulst",
      "10099": "Punktquelle",
      "10100": "Ausgedehnte Quelle",
      "10101": "Maximal zulässige Bestrahlung",
      "10102": "Zugängliche Strahlung",
      "10103": "Sicherheitsverhältnis für das Auge",
      "10104": "Auge",
      "10105": "Tatsächliche ZS",
      "10106": "Haut",
      "10107": "Sicherheitsverhältnis für die Haut",
      "10108": "Die eingegebene Konfiguration ist für das Auge gefährlich",
      "10109": "Die eingegebene Konfiguration ist für das Auge sicher",
      "10110": "Die eingegebene Konfiguration ist für das Auge bedingt sicher",

      "101108": "Die eingegebene Konfiguration ist für das Haut gefährlich",
      "101109": "Die eingegebene Konfiguration ist für das Haut sicher",
      "101110": "Die eingegebene Konfiguration ist für das Haut bedingt sicher",
      "10111": "Strahleigenschaften",
      "10112": "Spotgröße",
      "10113": "Grenzblende",
      "10114": "Anwendbarer Strahlbereich",
      "10115": "Spektrum",
      "10116": "Nomineller Augen-Gefahrenabstand",
      "10117": "Erweiterter nomineller Augen-Gefahrenabstand",
      "10118": "MZB Details",
      "10119": "Mehr Informationen",
      "10120": "Winkelparameter",
      "10121": "Anzahl der Pulse",
      "10122": "Dauer der Pulsfolge",
      "10123": "Laserschutzbrillen",
      "10124": "Korrekturfaktoren & Zeitbasis",
      "101124": "Korrekturfaktor",
      "101125": "Zeitbasis",

      "10125": "Wenn diese Einstellung aktiviert ist, wird das Fenster mit dem Haftungsausschluss ausgeblendet, das erscheint, wenn Sie versuchen, die Berechnung abzuschicken.",
      "10126": "Einstellungen übernehmen",
      "10127": "Haftungsausschluss ausblenden",
      "10128": "Nicht mehr anzeigen",
      "10129": "Verbleibende Berechnungen",
      "10130": "Grenzwerte der zugänglichen Strahlung",
      "10131": "Allgemein",
      "10132": "Klasse",
      "10133": "Laserklasse",
      "10134": "Bedingung",
      "10135": "Dieses Produkt ist als Laserlasse 4 klassifiziert",
      "10136": "Hier Labels für die Laserklassifizierung kaufen!",
      "10137": "Möchten Sie, dass Ihr Produkt akkreditiert wird?",
      "10138": "Besuchen Sie unser akkreditiertes Prüfzentrum",
      "10139": "Mehr Informationen",
      "10140": "für",
      "10141": "Gefährdungsgrad der Emission",
      "10142": "Bestanden/Nicht bestanden",
      "10143": "Pulsdauer ",
      "10144": "Zeitbasis ",
      "10145": "Wert ",
      "10146": "Durchmesser der Messblende und Messabstände",
      "10147": "Blendenöffnung",
      "10148": "Blendenabstand",
      "10149": "Scheinbare Größe",
      "10150": "Optische Dichte",
      "10151": "Ergebnisse ",
      "10152": "RB Schutzstufe",
      "10153": "LB Schutzstufe für Glas",
      "10154": "LB Schutzstufe für Kunststoff",
      "10155": "Nominelle OD",
      "10156": "Die nominale optische Dichte wird mit dem Logarithmus des Quotienten aus der zugänglichen Strahlung und der maximal zulässigen Bestrahlung berechnet",
      "10157": "Die Formel wird zur Gewährleistung der Lasersicherheit verwendet, indem die erforderliche Abschwächung der Laserstrahlung bestimmt wird",
      "10158": "Wo ",
      "10159": "Lösung ",
      "10160": "Hinweis: Je höher der OD, desto größer die erforderliche Abschwächung zum Schutz vor gefährlicher Laserstrahlung",
      "10161": "Bleiben Sie geschützt. Kaufen Sie hier Ihre Laserschutzbrille ",
      "10162": "Die Norm EN 208 gilt nur für Laser, die Wellenlängen im sichtbaren Bereich des Spektrums emittieren",
      "10163": "Wenn der Strahldurchmesser größer als die Grenzblende von 7mm ist, kann die Auswahl auf der Grundlage des Anteils der Leistung erfolgen, der durch eine 7-mm-Blende hindurchgehen würde",
      "10164": "Wenn der Strahldurchmesser größer als die Grenzblende von 7mm ist",
      "10165": "Angepasste Leistung/Energie",
      "10166": "Verwenden Sie die angepasste Leistung/Energie, um die entsprechende RB-Nummer aus BS EN 208 zu bestimmen",
      "10167": "Zur Berechnung der angepassten Leistungs-/Energiedichte",
      "10168": "Wenn der Strahldurchmesser größer als 15mm ist, sind die Funktionswerte für d = 15mm zu verwenden",
      "10169": "Multiplizieren Sie die tatsächliche Leistungs-/Energiedichte mit dem Korrekturfaktor",
      "10170": "Formel ",
      "10171": "Verwenden Sie den korrigierten Wert, um die entsprechende Brillenschutzstufe aus Tabelle b1 von BS EN 207:2017 zu bestimmen",
      "10172": "Hinweis: Diese Anpassung stellt sicher, dass die berechneten Werte mit den Standardrichtlinien für Laserschutzbrillen mit Glasfilter übereinstimmen",
      "101172": "Hinweis: Diese Anpassung stellt sicher, dass die berechneten Werte mit den Standardrichtlinien für Laserschutzbrillen mit Kunststoff übereinstimmen",

      "10173": "Ist etwas mit den Ergebnissen nicht in Ordnung? Klicken Sie hier, um einen Fehler zu melden.",

      "50001": "Online Laser Sicherheits Kalkulationssoftware zu IEC 60825-1",
      "50002": "Realtime LSS ist der benutzerfreundliche Online-Lasersicherheit Rechner, der vollständig der internationalen Norm IEC 60825-1: Sicherheit von Laser Produkten – Teil 1 entspricht.",
      "50003": "Probieren Sie es jetzt",
      "50004": "Preise",
      "50005": "RealTime LSS bietet Zugriff von unterwegs und ist somit ideal für die schnelle Beurteilungen im Labor oder vor Ort.",
      "50006": "Berechnen Sie wichtigsten Laser Sicherheitsparameter einschließlich::",
      "50007": "Berechnung der maximal zulässigen Exposition (MPE)",
      "50008": "Berechnung der Emissionsgrenzwerte (AEL)",
      "50009": "Laserklassifizierung",
      "50010": "Berechnungen zur diffusen Reflexion",
      "50011": "Fiber Optics Bewertung",
      "50012": "RealTime LSS wurde von Lasermet entwickelt, einer weltweit anerkannten Kompetenz im Bereich Lasersicherheit. Mit jahrzehntelanger Erfahrung in Laser Sicherheitsstandards, Beratung und Technologie bietet Lasermet zuverlässige Lösungen für Gewährleistung und Einhaltung der IEC-60825-1 Norm und anderen internationalen Vorschriften.",
      "50013": "Besuchen Sie Lasermet",
      "50014": "Preise",
      "50015": "Schluss mit dem Rätselraten rund um die Lasersicherheit – kaufen Sie Ihr Guthaben um sichere Entscheidungen Ihrer Lasersicherheit zu treffen",
      "50016": "Wählen Sie einen flexiblen Plan und beginnen Sie noch heute mit präzisen Lasersicherheit Berechnungen.",
      "50017": "Kalkulation",
      "50018": "Pro Kalkulation",
      "50019": "Ich kaufe für mich",
      "50020": "Ich kaufe für jemand anderen",
      "50021": "Um für eine andere Person zu kaufen, schließen Sie zunächst die Zahlung ab. Sie erhalten per E-Mail einen Lizenzschlüssel. Teilen Sie diesen Ihren Kunden oder Empfänger mit, damit dieser ein eigenes Konto aktivieren kann und seine Berechnungen direkt erhält",
      "50022": "Kaufvertrag",
      "50023": "E-mail wiederholen",
      "50024": "Firma",
      "50025": "Firmenadresse",
      "50026": "Weiter zum Checkout",
      "50027": "Sie haben es fast geschafft. ",
      "500127": "Melden Sie sich an",
      "500128": " Registrieren",
      "500129": "an um ihren individuellen Einkauf zu.",
      "500130": "oder",

      "50028": "Sie möchten es noch nicht kaufen? Dann testen Sie unseren kostenlosen Kalkulator",
      "50029": "Starten Sie Ihre kostenlose Kalkulkation",
      "50030": "Kostenlose Kalkulation",
      "50031": "Bearbeiten Sie Ihre Abo",
      "50032": "Jetzt Abo abschliessen",
      "50033": "Lizenzschlüssel aktivieren",
      "50034": "Aktivieren Sie Lizenz Ihre Einkaufes hier",
      "50035": "Wenn Ihr Unternehmen bereits eine Lizenz erworben hat, geben Sie unten den Lizenzschlüssel ein, um auf das Abo zugreifen zu können.",
      "50036": "Wie funktioniert es",
      "50037": "Diese Funktion ist für Lizenzschlüssel vorgesehen, die über die Beschaffungs- oder Einkaufsabteilung eines Unternehmens erworben wurden.",
      "50038": "Nach dem Kauf wird der Lizenzschlüssel an Ihren angegebenen Ansprechpartner (z. B. Einkäufer oder Administrator) gesendet.",
      "50039": "Fordern Sie den Lizenzschlüssel intern an und geben Sie ihn hier bitte ein:",
      "50053": "Erfolgeich!",
      "50054": "Ihr Passwort wurde erfolgreich geändert",
      "50055": "Free",
      "50056": "Testen Sie vor dem Kauf unseren voreingestellten IEC 60825-Lasersicherheit Rechner!",
      "50057": "Sie verwenden derzeit die kostenlose Version des Rechners. Diese Version verwendet voreingestellte Werte, die nicht geändert werden können. Für die vollständige Anpassung und ein detaillierteres Ergebnis aktualisieren Sie bitte auf die",
      "50058": "Premium Abo",
      "50060": "Bitte suchen Sie in Ihrem E-Mail  Posteingang oder schauen Sie im Spam-Ordner nach dem Bestätigungscode und geben Sie ihn unten ein.",
      "50061": "Bestätigen Sie Ihr Konto",
      "50062": "Lizenzschlüssel",
      "50063": "Aktivieren",
      "50064": "Die zugehörigen Guthaben werden Ihrem Konto sofort nach der Aktivierung gutgeschrieben.",

      //Disclaimer
      "60001": "Haftungsausschluss",
      "60002": "Das auf dieser Website bereitgestellte Programm zur Berechnung der Laserschutzparameter soll dem Benutzer bei der Berechnung von Laserschutztparametern auf der Grundlage der Norm IEC 60825-1 unterstützen. Obwohl wir uns bemühen, die Genauigkeit und Zuverlässigkeit der Berechnungen zu gewährleisten, wird das Programm ohne Mängelgewährleistung und ohne jegliche ausdrückliche oder stillschweigende Garantie zur Verfügung gestellt.",
      "60003": "Genauigkeit und Beschränkungen:",
      "60004": "Genauigkeit:",
      "60005": "Das Programm ist so konzipiert, dass es in der überwiegenden Mehrheit der Szenarien genaue Berechnungen liefert, mit einem erwarteten Genauigkeitsgrad von deutlich über 99 %. Aufgrund der Komplexität und der großen Anzahl möglicher Szenarien ist es jedoch nicht möglich, die Genauigkeit jeder einzelnen Berechnung zu überprüfen. Die Nutzer sollten sich darüber im Klaren sein, dass das Programm in manchen Fällen falsche Ergebnisse liefert.",
      "60006": "Keine professionelle Beratung: ",
      "60007": "Die in diesem Programm enthaltenen Berechnungen und Informationen dienen nur zu Informationszwecken und stellen keine professionelle Beratung dar. Die Benutzer sollten sich bei sicherheitsrelevanten Entscheidungen nicht ausschließlich auf das Programm verlassen, sondern einen qualifizierten Fachmann um Rat fragen, der mit Ihrer Situation vertraut ist.",
      "60008": "Beschränkung der Haftung:",
      "60009": "In keinem Fall haften Lasermet, deren Tochtergesellschaften oder Lizenzgeber für direkte, indirekte, zufällige, besondere oder Folgeschäden, die sich aus oder in Verbindung mit der Nutzung des Programms ergeben, einschließlich, aber nicht beschränkt auf Fehler oder Auslassungen in den Berechnungen, selbst wenn auf die Möglichkeit solcher Schäden hingewiesen wurde.",
      "60010": "Verantwortung des Benutzers:",
      "60011": "Der Benutzer ist dafür verantwortlich, die mit dem Programm erzielten Ergebnisse zu überprüfen und sicherzustellen, dass sie allen geltenden Sicherheitsnormen und -vorschriften entsprechen. Lasermet übernimmt keine Verantwortung für die Richtigkeit oder Vollständigkeit der Berechnungen oder für Maßnahmen, die auf der Grundlage der vom Programm gelieferten Ergebnisse ergriffen werden.",
      "60012": "Mit der Nutzung dieses Tools erkennen Sie die Bedingungen dieses Haftungsausschlusses an und übernehmen die volle Verantwortung für alle Risiken, die mit der Nutzung verbunden sind.",

      //Privacy Policy
      "60013": "Datenschutzerklärung",
      "60014": "Lasermet Ltd. betreibt den RealTime LSS-Rechner und nimmt den Schutz Ihrer Daten ernst. Diese Datenschutzerklärung erläutert, welche persönlichen Daten wir sammeln, wie wir sie verwenden, wie wir sie schützen und welche Rechte Sie in Bezug auf diese Daten haben.",
      "60015": "Informationen, die wir sammeln",
      "60016": "Wir sammeln die folgenden persönlichen Daten, um unsere Dienste bereitzustellen und zu verbessern:",
      "60017": "Name: Wird verwendet, um Ihre Erfahrung und Ihr Konto zu personalisieren.",
      "60018": "E-Mail: Für die Kontoregistrierung und den sicheren Zugang.",
      "60019": "Passwort: Wird in verschlüsselter Form gespeichert, um die Sicherheit des Kontos zu gewährleisten.",
      "60020": "Geolokalisierungsdaten: Wir verwenden IPinfo.io, um allgemeine Standortinformationen, einschließlich Ihrer IP-Adresse, zu sammeln, und zwar ausschließlich zum Zweck der Bestimmung Ihrer Währung. Diese Standortdaten werden in einem Cookie gespeichert.",
      "60021": "Wir erheben keine weiteren personenbezogenen Daten und versenden keine Marketing-E-Mails oder Newsletter.",
      "60022": "Verwendung von Cookies und JWT-Web-Token",
      "60023": "Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, um bestimmte Informationen über Ihre Interaktionen mit der App zu speichern. Wir verwenden Cookies ausschließlich für die folgenden Zwecke:",
      "60024": "Authentifizierung: Wir speichern JWT-Web-Tokens in Cookies für sichere Anmeldesitzungen. Dadurch wird sichergestellt, dass die Benutzer während der Nutzung der Plattform sicher eingeloggt bleiben.",
      "60025": "Sitzungsverwaltung: Cookies helfen bei der Speicherung von Benutzerpräferenzen und -einstellungen, um Ihr Erlebnis zu verbessern.",
      "60026": "Währungsbestimmung: Geolocation-Daten werden verwendet, um die passende Währung für Transaktionen zu bestimmen. Wenn die Geolokalisierungsdienste deaktiviert oder nicht verfügbar sind, wird eine Standardwährung (Britische Pfund) verwendet. Es ist den Nutzern möglicherweise nicht möglich, manuell eine andere Währung auszuwählen. Wir speichern oder verwenden diese Daten nicht für andere Zwecke.",
      "60027": "Wir setzen keine Cookies für Werbe- oder Trackingzwecke ein. Auf unserer Plattform sind keine Tracking-Tools von Drittanbietern wie Google Analytics oder Facebook Pixel implementiert.",
      "60028": "Sie können Cookies verwalten oder deaktivieren, indem Sie Ihre Browsereinstellungen anpassen. Bitte beachten Sie jedoch, dass die Deaktivierung von Cookies Ihre Fähigkeit beeinträchtigen kann, bestimmte Funktionen der App zu nutzen, insbesondere solche, die mit der Sitzungsauthentifizierung zusammenhängen.",
      "60029": "Wie wir Ihre Informationen verwenden",
      "60030": "Die von uns erfassten persönlichen Informationen werden verwendet für:",
      "60031": "die Erstellung und Pflege Ihres Benutzerkontos.",
      "60032": "die sichere Authentifizierung von Benutzersitzungen.",
      "60033": "die Aktivierung von Geolokalisierungsfunktionen für die Währungsbestimmung.",
      "60034": "die sichere Abwicklung von Zahlungen über Stripe.",
      "60035": "Wir verkaufen und vermieten Ihre persönlichen Informationen nicht und geben sie auch nicht an Dritte zu Marketingzwecken weiter.",
      "60036": "Zahlungen",
      "60037": "Wir wickeln Zahlungen über Stripe ab, ein sicheres Zahlungsgateway eines Drittanbieters. Ihre Zahlungsdaten werden direkt von Stripe verarbeitet, und wir speichern keine Zahlungsdaten auf unseren Servern. Bitte lesen Sie die Datenschutzrichtlinien von Stripe, um weitere Einzelheiten über deren Praktiken zu erfahren.",
      "60038": "Datenschutz und Sicherheit",
      "60039": "Wir verpflichten uns, die Sicherheit Ihrer Daten zu gewährleisten. Wir haben geeignete technische und organisatorische Maßnahmen getroffen, um Ihre persönlichen Daten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen. Passwörter werden verschlüsselt gespeichert, und JWT-Tokens werden sicher verwaltet.",
      "60040": "Einhaltung von Rechtsvorschriften",
      "60041": "California Online Privacy Protection Act (CalOPPA): Wir ermöglichen es den Nutzern, unsere Website anonym zu besuchen, und aktualisieren unsere Datenschutzrichtlinien bei Bedarf. Allgemeine Datenschutzverordnung (GDPR): Benutzer in der EU haben das Recht, auf ihre persönlichen Daten zuzugreifen, sie zu ändern oder zu löschen. Sie können uns unter office@lasermet.com kontaktieren, um diese Rechte auszuüben. Kalifornisches Verbraucherschutzgesetz (CCPA): In Kalifornien ansässige Personen haben das Recht, Informationen über die von uns erfassten personenbezogenen Daten anzufordern und deren Löschung zu verlangen. Wir verkaufen keine personenbezogenen Daten.",
      "60042": "Ihre Rechte und Wahlmöglichkeiten",
      "60043": "Sie haben die folgenden Rechte in Bezug auf Ihre personenbezogenen Daten:",
      "60044": "Zugang: Sie können eine Kopie der personenbezogenen Daten anfordern, die wir über Sie gespeichert haben.",
      "60045": "Berichtigung: Sie können uns auffordern, unrichtige Daten zu korrigieren",
      "60046": "Löschung:",
      "60047": "Sie können vorbehaltlich gesetzlicher Bestimmungen die Löschung Ihrer personenbezogenen Daten verlangen.",
      "60048": "Opt-Out:",
      "60049": "Sie können bestimmte Datenerfassungspraktiken ablehnen, indem Sie Cookies in Ihren Browsereinstellungen deaktivieren.",
      "60050": "Änderungen dieser Datenschutzerklärung",
      "60051": "Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Alle Änderungen werden auf unserer Website mit einem überarbeiteten Datum des Inkrafttretens veröffentlicht. Wir empfehlen Ihnen, diese Erklärung regelmäßig zu überprüfen.",
      "60052": "Links zu anderen Seiten",
      "60053": "Links zu anderen Seiten in dieser Webanwendung führen Sie zu unserer offiziellen Lasermet Website. Die Links zu unseren sozialen Medien führen jedoch zu unseren Profilen auf den jeweiligen Plattformen. Diese Datenschutzerklärung gilt nicht für diese Dienste von Drittanbietern, und wir sind nicht verantwortlich für deren Datenschutzpraktiken. Wir empfehlen Ihnen, deren Datenschutzerklärungen zu lesen, bevor Sie persönliche Daten angeben.",
      "60054": "Kontakt",
      "60055": "Wenn Sie Fragen oder Bedenken zu dieser Datenschutzerklärung haben oder Ihre Rechte in Bezug auf Ihre persönlichen Daten ausüben möchten, ",
      "60056": "wenden Sie sich bitte an uns:",

      //Terms and Conditions
      "60057": "Allgemeine Geschäftsbedingungen",
      "60058": "Willkommen beim Programm zur Berechnung der Lasersicherheitsparameter, bekannt als RealTime LSS („das Programm“ oder „Programm“), bereitgestellt von Lasermet („Unternehmen“, „wir“ oder „uns“). Diese Nutzungsbedingungen („Bedingungen“) regeln Ihren Zugriff auf das Programm und dessen Nutzung. Durch den Zugriff auf das Programm oder dessen Nutzung erkennen Sie („Nutzer“ oder „Sie“) diese Bedingungen an und erklären sich mit ihnen einverstanden. Wenn Sie mit irgendeinem Teil dieser Bedingungen nicht einverstanden sind, müssen Sie den Zugriff auf das Programm oder dessen Nutzung unterlassen.",
      "60059": "Zu Ihrer Erleichterung haben wir die Abschnitte mit Überschriften versehen, um Ihnen die Navigation zu erleichtern.",
      "60060": "Allgemeine Informationen",
      "60061": "Zweck:",
      "60062": "Das Programm soll den Benutzer bei der Berechnung von Lasersicherheitsparametern in Übereinstimmung mit der Norm IEC 60825-1 unterstützen. Es soll eine allgemeine Anleitung zu Laserschutzmaßnahmen geben, indem es Berechnungen auf der Grundlage der vom Benutzer eingegebenen Daten erstellt. Das Programm ist kein Ersatz für eine fachkundige Beratung oder ein professionelles Urteil.",
      "60063": "Nur zu Informationszwecken:",
      "60064": "Das Programm wird ausschließlich zu Informations- und Bildungszwecken bereitgestellt. Es ersetzt nicht die Notwendigkeit einer professionellen Beratung oder die Einhaltung formaler Laserschutzvorschriften. Die Benutzer müssen die Genauigkeit und Anwendbarkeit der mit dem Programm erstellten Berechnungen auf ihre spezifischen Umstände selbst überprüfen.",
      "60065": "Behördenspezifische Konformität:",
      "60066": "Das Programm ist nicht auf die spezifischen Laserschutzanforderungen der einzelnen Staaten oder Länder zugeschnitten. Die Benutzer sind für die Einhaltung ihrer spezifischen Gesetze verantwortlich.",
      "60067": "Akzeptanz der Bedingungen:",
      "60068": "Indem Sie auf das Programm zugreifen oder es nutzen, bestätigen Sie, dass Sie diese Nutzungsbedingungen gelesen und verstanden haben und sie in ihrer Gesamtheit akzeptieren. Wenn Sie mit diesen Bedingungen nicht einverstanden sind, müssen Sie von der Nutzung des Programms Abstand nehmen.",
      "60069": "Verantwortlichkeiten der Benutzer",
      "60070": "Genauigkeit der Eingaben:",
      "60071": "Die Genauigkeit und Relevanz der Ergebnisse des Programms hängen vollständig von den Dateneingaben der Benutzer ab. Es liegt in Ihrer Verantwortung, genaue, vollständige und relevante Daten einzugeben, um aussagekräftige Ergebnisse zu erzielen.",
      "60072": "Überprüfung der Ergebnisse:",
      "60073": "Sie erkennen an und erklären sich damit einverstanden, dass die vom Programm gelieferten Ergebnisse Schätzungen sind, die auf der Norm IEC 60825-1 basieren und möglicherweise nicht die landesspezifischen Anforderungen berücksichtigen, einschließlich derer in Illinois. Es liegt in Ihrer Verantwortung, die Genauigkeit dieser Ergebnisse zu überprüfen, bevor Sie sie in einem realen Kontext anwenden.",
      "60074": "Verbotene Aktivitäten:",
      "60075": "Sie verpflichten sich, Folgendes zu unterlassen:",
      "60076": "Das Programm für ungesetzliche, irreführende oder betrügerische Zwecke zu verwenden.",
      "60077": "Auf das Programm mit nicht autorisierten Mitteln zuzugreifen, einschließlich automatisierter Methoden wie Bots oder Skripts.",
      "60078": "Zu versuchen, das Programm oder die ihm zugrunde liegenden Algorithmen zurückzuentwickeln, zu modifizieren, zu kopieren oder davon abgeleitete Werke zu erstellen.",
      "60079": "Die Ergebnisse des Programms in einer Art und Weise zu verbreiten oder weiterzugeben, die den Zweck des Programms falsch wiedergibt.",
      "60080": "Den Zugang mit einem Benutzer zu teilen, der nicht als Vertreter des genannten Benutzers handelt.",
      "60081": "Einhaltung der Gesetze des Staates Illinois und des Bundes:",
      "60082": "Benutzer, die in ihrem jeweiligen Bundesstaat oder Bezirk tätig sind, müssen sicherstellen, dass sie alle geltenden Gesetze einhalten, einschließlich derer, die die Lasersicherheit, die Sicherheit am Arbeitsplatz und die Strahlungsüberwachung regeln. Den Benutzern wird empfohlen, qualifizierte Fachleute zu Rate zu ziehen, die mit den landesspezifischen Sicherheitsvorschriften vertraut sind.",
      "60083": "Ausschluss von Garantien",
      "60084": "„Wie besehen“ und „Wie verfügbar“ Basis:",
      "60085": "Das Programm wird „wie besehen“ und „wie verfügbar“ zur Verfügung gestellt, ohne ausdrückliche oder stillschweigende Garantien jeglicher Art, einschließlich, aber nicht beschränkt auf Garantien der Marktgängigkeit, der Eignung für einen bestimmten Zweck, der Nichtverletzung von Rechten oder des fehlerfreien Betriebs.",
      "60086": "Keine Garantien:",
      "60087": "Lasermet übernimmt keine Garantie für die Zuverlässigkeit, Vollständigkeit oder Genauigkeit der Ergebnisse des Programms. Der Benutzer verlässt sich auf das Programm auf eigenes Risiko.",
      "60088": "Keine professionelle Beratung:",
      "60089": "Das Programm stellt keine rechtliche, technische oder professionelle Beratung dar. Bei Entscheidungen, die die Einhaltung von Sicherheitsvorschriften betreffen, sollten die Benutzer einen zertifizierten Laserschutzbeauftragten oder andere qualifizierte Fachleute zu Rate ziehen.",
      "60090": "Beschränkung der Haftung",
      "60091": "Beschränkung auf das gesetzlich zulässige Maß:",
      "60092": "Lasermet und seine Tochtergesellschaften, leitenden Angestellten, Mitarbeiter und Vertreter haften nicht für direkte, indirekte, beiläufige oder Folgeschäden, die sich aus der Verwendung des Programms ergeben, soweit dies gesetzlich zulässig ist. Diese Einschränkung schließt ein, ist aber nicht beschränkt auf:",
      "60093": "Personen- oder Sachschäden.",
      "60094": "Verlust von Gewinnen, Daten oder Geschäftsmöglichkeiten.",
      "60095": "Jegliches Vertrauen auf die Ergebnisse des Programms.",
      "60096": "Risikoübernahme:",
      "60097": "Durch die Nutzung des Programms erkennen Sie die inhärenten Risiken an, die mit dem Vertrauen auf automatische Berechnungen verbunden sind, und akzeptieren diese. Sie erklären sich damit einverstanden, dass Lasermet nicht für nachteilige Ergebnisse verantwortlich ist, die sich aus einem solchen Vertrauen ergeben.",
      "60098": "Entschädigung:",
      "60099": "Sie erklären sich damit einverstanden, Lasermet, seine verbundenen Unternehmen, leitenden Angestellten, Mitarbeiter und Vertreter von jeglichen Ansprüchen, Haftungen, Schäden oder Kosten freizustellen, die sich aus Ihrer Nutzung des Programms oder der Verletzung dieser Bedingungen ergeben.",
      "60100": "Geistiges Eigentum",
      "60101": "Eigentumsrecht:",
      "60102": "Alle Rechte, Titel und Interessen an dem Programm, einschließlich dessen Inhalt, Design, Algorithmen und Funktionalität, bleiben das ausschließliche Eigentum von Lasermet. Diese Rechte sind durch US-amerikanische und internationale Gesetze zum Urheberrecht, Warenzeichen und geistigem Eigentum geschützt.",
      "60103": "Lizenz:",
      "60104": "Lasermet gewährt Ihnen eine nicht-exklusive, begrenzte, widerrufliche Lizenz für den Zugriff auf das Programm und dessen Nutzung für den vorgesehenen Zweck. Mit dieser Lizenz werden keine Eigentumsrechte an Sie übertragen.",
      "60105": "Beschränkungen:",
      "60106": "Sie dürfen nicht:",
      "60107": "Das Programm ohne vorherige schriftliche Zustimmung von Lasermet vervielfältigen, verändern oder verbreiten.",
      "60108": "Entfernen, Ändern oder Unkenntlichmachen von Eigentumshinweisen auf dem Programm.",
      "60109": "Datenschutz",
      "60110": "Datenerhebung:",
      "60111": "Das Programm kann anonymisierte Daten sammeln, um seine Funktionalität und Leistung zu verbessern.",
      "60112": "Geltendes Recht und Streitbeilegung",
      "60113": "Geltendes Recht:",
      "60114": "Diese Bedingungen unterliegen den Gesetzen des Staates Illinois und werden in Übereinstimmung mit diesen ausgelegt, unter Ausschluss der Grundsätze des Kollisionsrechts.",
      "60115": "Gerichtsbarkeit und Gerichtsstand:",
      "60116": "Alle Rechtsstreitigkeiten, die sich aus diesen Bedingungen ergeben, unterliegen der ausschließlichen Zuständigkeit der Staats- und Bundesgerichte in Cook County, Illinois.",
      "60117": "Schiedsgerichtsklausel:",
      "60118": "Streitigkeiten, die nicht gütlich beigelegt werden können, werden einem verbindlichen Schiedsverfahren unterzogen, das von einer in Illinois ansässigen Schiedsinstitution, wie der American Arbitration Association (AAA), verwaltet wird.",
      "60119": "Das Schiedsgerichtsverfahren findet in Cook County, Illinois, statt und wird nach den Regeln der AAA durchgeführt.",
      "60120": "Die Entscheidung des Schiedsrichters ist endgültig und für beide Parteien bindend.",
      "60121": "Änderungen der Bedingungen",
      "60122": "Recht auf Änderung:",
      "60123": "Lasermet behält sich das Recht vor, diese Bedingungen jederzeit und ohne vorherige Ankündigung zu aktualisieren oder zu ändern.",
      "60124": "Benachrichtigung:",
      "60125": "Änderungen treten mit der Veröffentlichung der aktualisierten Bedingungen auf unserer Website in Kraft. Die fortgesetzte Nutzung des Programms gilt als Zustimmung zu den aktualisierten Bedingungen.",
      "60126": "Beendigung",
      "60127": "Recht zur Beendigung:",
      "60128": "Lasermet kann Ihren Zugang zum Programm nach eigenem Ermessen, mit oder ohne Grund oder Benachrichtigung, beenden oder aussetzen.",
      "60129": "Wirkung der Beendigung:",
      "60130": "Mit der Kündigung erlöschen sofort alle unter diesen Bedingungen gewährten Rechte.",
      "60131": "Annahme der Bedingungen",
      "60132": "Indem Sie auf „Ich stimme zu“ klicken oder das Programm nutzen, bestätigen Sie, dass Sie diese Nutzungsbedingungen gelesen und verstanden haben und ihnen in ihrer Gesamtheit zustimmen."

    }
  }
}
export default translations;